<template>
  <div>
    <form @submit="submitForm">
      <div class="card">
        <div class="card-header p-2">
          <ul class="nav nav-pills">
            <li class="nav-item"><a class="nav-link active" href="#activity" data-toggle="tab" v-on:click="currentTab = 'profile'">Basic Profile</a></li>
          </ul>
        </div>
        <div class="card-body">
          <div class="tab-content">
            <div class="tab-pane active" id="activity">
              <h4>General Information</h4>
              <div class="row">
                <div class="form-group col-md-3">
                  <label class="form-label">Category</label>
                  <v-select placeholder="--Select--" label="Title" :options="categories" v-model="form.BP_ORGCATEGORY" :reduce="x=>x.ID" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Partner Type</label>
                  <v-select placeholder="--Select--" label="Title" :options="partnerTypes" v-model="form.PTR_ID" :reduce="x=>x.ID" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Status</label>
                  <v-select placeholder="--Select--" label="Title" :options="statuses" v-model="form.PST_ID" :reduce="x=>x.ID" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Tax</label>
                  <v-select placeholder="--Select--" label="Title" :options="taxes" v-model="form.TX_ID" :reduce="x=>x.ID" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Tax Payer</label>
                  <v-select placeholder="--Select--" :options="[{ label: 'Yes', value: '1' },{ label: 'No', value: '0' }]" v-model="form.BP_ISACTTAXPAY" label="label" :reduce="option => option.value" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Business Nature</label>
                  <v-select placeholder="--Select--" label="Title" :options="businessNatures" v-model="form.BN_ID" :reduce="x=>x.ID" />
                </div>
              </div>
              <h4>Personal Information</h4>
              <div class="row">
                <div class="form-group col-md-3">
                  <label class="form-label">Title</label>
                  <v-select placeholder="--Select--" label="Title" :options="titles" v-model="form.PT_ID" :reduce="x=>x.ID" />
                </div>
                <div class="form-group col-md-9">
                  <label class="form-label">Name</label>
                  <input type="text" class="form-control" v-model.trim="form.BP_DSC" required />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Passport</label>
                  <input type="text" class="form-control" v-mask="'#########'" v-model="form.BP_PASSPORTNO" />
                </div>
                <div v-if="form.PTR_ID != 1 && form.PTR_ID != 17" class="form-group col-md-3">
                  <label class="form-label">GST</label>
                  <input type="text" class="form-control" v-mask="'###############'" v-model="form.BP_GST_NO" />
                </div>
                <div class="form-group col-md-3" v-if="form.PTR_ID == 1 || form.PTR_ID == 17">
                  <label class="form-label">CNIC</label>
                  <input type="text" class="form-control" v-mask="'#####-#######-#'" v-model="form.BP_NIC_NO" required />
                </div>
                <div class="form-group col-md-3" v-if="form.PTR_ID != 1 && form.PTR_ID != 17">
                  <label class="form-label">NTN</label>
                  <input type="text" class="form-control" v-model="form.BP_NTN_NO" minlength="7" maxlength="9" required />
                </div>
              </div>

              <h4>Contact Information</h4>
              <div class="row">
                <div class="form-group col-md-3">
                  <label class="form-label">Country</label>
                  <v-select placeholder="--Select--" label="Title" :options="countries" v-model="form.C_CODE" :reduce="x=>x.ID" @input="fetchStates" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">State</label>
                  <v-select placeholder="--Select--" label="Title" :options="states" v-model="form.PVN_ID" :reduce="x=>x.ID" @input="fetchCities" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">City</label>
                  <v-select placeholder="--Select--" label="Title" :options="cities" v-model="form.CTY_ID" :reduce="x=>x.ID" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Contact Person</label>
                  <input type="text" class="form-control" v-model="form.BP_CONTACT_PERSON" required />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Mobile No</label>
                  <input type="tel" class="form-control" v-mask="'###########'" pattern=".{11,11}" title="11 digits required" v-model="form.BP_MOBILE" required />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Phone No</label>
                  <input type="tel" class="form-control" v-mask="'###########'" pattern=".{11,11}" title="11 digits required" v-model="form.BP_PHONE" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Fax No</label>
                  <input type="tel" class="form-control" v-mask="'############'" v-model="form.BP_FAX" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">P.O BOX</label>
                  <input type="text" class="form-control" v-mask="'#####'" v-model="form.BP_PO_BOX" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Email</label>
                  <input type="email" class="form-control" v-model="form.BP_EMAIL_ADDRESS" required />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Website</label>
                  <input type="text" class="form-control" v-model="form.BP_URL_ADDRESS" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">UAN No</label>
                  <input type="tel" class="form-control" v-mask="'#########'" v-model="form.BP_UAN" />
                </div>
              </div>
              <h4>Address</h4>
              <table class="col-md-12 table-sm table-bordered">
                <thead class="bg-custom">
                  <tr>
                    <th>Sr.No</th>
                    <th>Address</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(address, index) in addresses" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <input class="form-control" v-model="address.ADD_ADDRESS" placeholder="Enter address" required />
                    </td>
                    <td>
                      <input type="checkbox" v-model="address.ADD_ISACTIVE" :true-value="1" :false-value="0" />
                      {{ address.ADD_ISACTIVE ? 'Active' : 'Inactive' }}
                    </td>
                    <td>
                      <button type="button" class="btn btn-danger" @click="removeAddress(index)" :disabled="addresses.length === 1">
                        <i class="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4">
                      <button type="button" class="btn btn-block btn-secondary" @click="addAddress">
                        Add Another Address
                      </button>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <a class="btn btn-primary" href="../UIC/BasicClientProfileList">Back to List</a>
          <button type="submit" class="btn btn-success float-right mr-1">Save Basic Profile</button>
          <button type="button" class="btn btn-danger float-right mr-1" @click="clearForm">Clear</button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        addresses: [{
          ADD_ID: null,
          BP_ID: null,
          ADD_ADDRESS: '',
          ADD_ISACTIVE: 1
        }],
        ALLOTMENT: [{
          BA_ID: null,
          BP_ID: null,
          BA_BRANCH: '',
          BA_ISACTIVE: 1
        }], //SAME AS ASSIGN
        form: {
          BP_ORGCATEGORY: '',   //category
          PTR_ID: '',           //PartnerType
          PST_ID: '',           //Status
          TX_ID: '',            //Tax
          BP_ISACTTAXPAY: '',   //taxPayer
          BN_ID: '',            //businessNatures
          PT_ID: '',            //title
          BP_DSC: '',           //Name
          BP_PASSPORTNO: '',    //Passport
          BP_GST_NO: '',
          BP_NIC_NO: '',
          BP_NTN_NO: '',
          C_CODE: '',            //country
          PVN_ID: '',            //state
          CTY_ID: '',            //city
          BP_CONTACT_PERSON: '',
          BP_MOBILE: '',
          BP_PHONE: '',
          BP_FAX: '',
          BP_PO_BOX: '',
          BP_EMAIL_ADDRESS: '',
          BP_URL_ADDRESS: '',    //website
          BP_UAN: '',
          BP_UAN_NO: '',
          BP_TYPE: 'CLIENT'
        },
        categories: [],
        partnerTypes: [],
        statuses: [],
        taxes: [],
        businessNatures: [],
        titles: [],
        countries: [],
        states: [],
        cities: [],
      };
    },
    created() {
      this.pageload();
    },
    methods: {
      pageload() {
        var vm = this;
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id') ? urlParams.get('id') : 0;
        var uri = window.location.toString();
        if (uri.indexOf("?") > 0) {
          var clean_uri = uri.substring(0, uri.indexOf("?"));
          window.history.replaceState({}, document.title, clean_uri);
        }
        startReq();
        axios.get("/api/UICApi/pageloadClientProfile?id=" + id)
          .then(function (res) {
            endReq();
            vm.categories = res.data.categories;
            vm.partnerTypes = res.data.partnerTypes;
            vm.statuses = res.data.statuses;
            vm.taxes = res.data.taxes;
            vm.businessNatures = res.data.businessNatures;
            vm.titles = res.data.titles;
            vm.countries = res.data.countries;
            if (res.data.obj != null) {
              vm.form = res.data.obj;
              vm.addresses = res.data.add;
              vm.ALLOTMENT = res.data.branchAllot;
            }
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      },
      fetchStates() {
        var vm = this;
        axios.get('/api/UICApi/loadStates?countryId=' + vm.form.C_CODE)
          .then(function (res) {
            endReq();
            vm.states = res.data.states;
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      },

      fetchCities() {
        var vm = this;
        axios.get('/api/UICApi/loadCities?stateId=' + vm.form.PVN_ID)
          .then(function (res) {
            endReq();
            vm.cities = res.data.cities;
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      },
      addAddress() {
        this.addresses.push({
          ADD_ID: null,
          BP_ID: null,
          ADD_ADDRESS: '',
          ADD_ISACTIVE: 1
        });
      },
      removeAddress(index) {
        if (this.addresses.length > 1) {
          this.addresses.splice(index, 1);
        }
      },
      clearForm() {
        this.addresses = [{
          ADD_ID: null,
          BP_ID: null,
          ADD_ADDRESS: '',
          ADD_ISACTIVE: 1
        }],
          this.form = {
            BP_ID: 0,
            BP_ORGCATEGORY: '', //category
            PTR_ID: '', //PartnerType
            PST_ID: '', //Status
            TX_ID: '', //Tax
            BP_ISACTTAXPAY: '1', //taxPayer
            BN_ID: '', //businessNatures
            PT_ID: '', //title
            BP_DSC: '', //Name
            BP_PASSPORTNO: '', //Passport
            BP_GST_NO: '',
            BP_NIC_NO: '',
            BP_NTN_NO: '',
            C_CODE: '', //country
            PVN_ID: '', //state
            CTY_ID: '', //city
            BP_CONTACT_PERSON: '',
            BP_MOBILE: '',
            BP_PHONE: '',
            BP_FAX: '',
            BP_PO_BOX: '',
            BP_EMAIL_ADDRESS: '',
            BP_URL_ADDRESS: '', //website
            BP_UAN: '',

          };
      },
      submitForm(e) {
        var vm = this;
        e.preventDefault();
        startReq();

        axios.post('/api/UICApi/SaveClientProfile', {
          BPMain: vm.form,
          address: vm.addresses,
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Client profile Saved successfully!");
              vm.clearForm();
            }
            else {
              toastr.error("Failed to save client profile: " + res.data.msg);
            }
          })
          .catch((error) => {
            endReq();
            console.log(error);
            toastr.error("An error occurred while saving the profile.");
          });
      },
    },
  };
</script>
<style>
  h4 {
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 15px;
    font-weight: 600;
    border-bottom: 2px solid #4CAF50;
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/BasicClientProfile.vue